/**
 * @file Contains the definition of maps help with file generator
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import comment from './Win21Update1GeneratorComment';

/**
 * Mapping prefix text to state
 * The key is prefix text for each variable in Response_Update1.ini file
 * The value is the state name
 * @type {Map}
 */

export const state2PrefixMap = new Map([
    ['enableTracing', 'EnableTracing='],
    ['hideAllDialogs', 'HideAllDialogs='],
    ['forceReboot', 'ForceReboot='],
    ['preventReboot', 'PreventReboot='],
    ['checkRenameOperations', 'CheckRenameOperations='],
    ['stopAllServices', 'StopAllServices='],
    ['stopIIS', 'StopIIS='],
    ['logFile', 'LogFile='],

    ['hideWelcomeDialog', 'HideDialog='],
    ['removeAll', 'RemoveAll='],
    ['hideSummaryDialog', 'HideDialog='],

    ['hideFinishDialog', 'HideDialog='],
]);

/**
 * Mapping the comments that should appear before each prefix text
 * The key is prefix text for each variable in Response_Update1.ini file
 * The value is the comments content
 * @type {Map}
 */

export const state2CommentMap = new Map([
    ['enableTracing', comment.enableTracing],
    ['hideAllDialogs', ''],
    ['forceReboot', ''],
    ['preventReboot', ''],
    ['checkRenameOperations', ''],
    ['stopAllServices', ''],
    ['stopIIS', ''],
    ['logFile', ''],

    ['hideWelcomeDialog', comment.hideWelcomeDialog],
    ['removeAll', comment.removeAll],

    ['hideSummaryDialog', comment.hideSummaryDialog],

    ['hideFinishDialog', comment.hideFinishDialog],
]);
